export default __webpack_public_path__ + "static/media/start-full-transparent.a8c63194.gif";